import React, { useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import './scrollbutton.css'

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
   



const ScrollToTop = () => {
    const { y: pageYOffset } = useWindowScroll();
    const [visible, setVisiblity] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    var invisH = 1400; //ADJUST VALUES
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    },[]);

    useEffect(() => {
        if (windowDimensions.width < 460) {
          invisH = 1200; //ADJUST VALUES
        }
        else if (windowDimensions.width < 650) {
          invisH = 2500; //ADJUST VALUES
        }
        else if (windowDimensions.width < 800) {
            invisH = 1600; //ADJUST VALUES
        }
        
        if (pageYOffset < invisH) {
            setVisiblity(true);
        } else {
            setVisiblity(false);
        }
    }, [pageYOffset]);

    



    return (
        <a
        style={{display: visible ? 'inline' : 'none'}}
          className="Scrollwrapper"
          href="#partnerPackage"
        >
          <button
            className="ScrollButton"
          >
            Interested in Partnering? 
          </button>
        </a>
    )
};

export default ScrollToTop;